<script setup lang="ts">
// Pill de voltar [‹ Voltar] — mesmo desenho do botão da barra de jogo em
// fullscreen (casino/games/Bar.vue), extraído pra reuso fora dela.
// Sem onBack, o clique cai em router.back().
interface Props {
  label?: string;
  onBack?: () => void;
}

const props = withDefaults(defineProps<Props>(), {
  label: 'Voltar',
  onBack: undefined,
});

const router = useRouter();

function handleBack() {
  if (props.onBack) {
    props.onBack();
  } else {
    router.back();
  }
}
</script>

<template>
  <button
    aria-label="Voltar"
    class="back-pill"
    type="button"
    @click="handleBack"
  >
    <NuxtIcon
      class="back-pill-icon"
      name="arrows/chevron_left"
    />
    {{ label }}
  </button>
</template>

<style scoped lang="scss">
.back-pill {
  @apply inline-flex items-center shrink-0 rounded-[12px] text-white;

  height: 34px;
  padding: 0 14px;
  background: rgba(63, 63, 70, 0.4); // mesmo #3F3F46/40 dos botões de filtro
  // Tipografia do .back do Bar.vue (12/600, gap medido no Figma).
  gap: 8.5px;
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  -webkit-tap-highlight-color: transparent;
}

.back-pill:active {
  filter: brightness(0.94);
}

// Chevron FINO (arrows/chevron_left, viewBox 17×28) — as mesmas correções de
// caixa do Bar.vue: largura na proporção do traço e margin do NuxtIcon zerada.
.back-pill-icon {
  @apply inline-flex items-center;

  font-size: 12.2px;

  :deep(svg) {
    width: 0.607em;
    margin-bottom: 0;
  }
}
</style>
